import { render, staticRenderFns } from "./top.vue?vue&type=template&id=62b85c5d&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"
import style0 from "./top.vue?vue&type=style&index=0&id=62b85c5d&prod&lang=less&scoped=true"
import style1 from "./top.vue?vue&type=style&index=1&id=62b85c5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b85c5d",
  null
  
)

export default component.exports